<template>
    <div ref="gmap" style="height: 300px; width: 100%"></div>
</template>

<script>
    import gmapsInit from '../utils/gmaps'

    let map = null;
    let markers = [];

    export default {
        name: "GMaps",
        props: {
            /**
             * Array of coordinates [ {lat:Number, lng:Number}, ... ]
             */
            coords: {
                type: Array,
                default: function(){
                    return [];
                }
            }
        },
        watch: {
            coords() {
                this.mapCoords();
            }
        },
        methods: {
            mapCoords() {
                if (map && this.coords) {
                    // Clear markers and reset array
                    for(const i in markers){
                        markers[i].setMap(null);
                    }
                    markers = [];

                    //Create markers and bounds to encapsulate all of our markers
                    let bounds = new google.maps.LatLngBounds();

                    for (let i in this.coords) {

                        var marker = new google.maps.Marker({position: this.coords[i], map: map});
                        markers.push(marker);
                        bounds.extend(this.coords[i]);

                    }

                    //If bounds if there's markers
                    if(markers.length > 0)
                    {
                        var markerCluster = new MarkerClusterer(map, markers,
                        {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'});

                        map.fitBounds(bounds);
                    }


                }
            }
        },
        async mounted() {
            try {

                const google = await gmapsInit();

                map = new google.maps.Map(this.$refs.gmap, {
                    center: {lat: 51.4934, lng: 0},
                    zoom: 8
                });

                this.mapCoords();


            } catch (error) {
                console.error(error);
            }

        }
    }
</script>

<style scoped>

</style>
